var map = {
	"./#.svg": 62499,
	"./ai.svg": 63322,
	"./back.svg": 40873,
	"./camera.svg": 36333,
	"./chart.svg": 56136,
	"./check-box.svg": 92352,
	"./circle-close2.svg": 51843,
	"./circle.svg": 37972,
	"./close-box.svg": 83404,
	"./collect.svg": 6350,
	"./country/AD.svg": 51094,
	"./country/AE.svg": 14919,
	"./country/AF.svg": 50356,
	"./country/AG.svg": 22965,
	"./country/AI.svg": 83491,
	"./country/AL.svg": 48606,
	"./country/AM.svg": 92335,
	"./country/AO.svg": 2781,
	"./country/AQ.svg": 81803,
	"./country/AR.svg": 31064,
	"./country/AS.svg": 35305,
	"./country/AT.svg": 5862,
	"./country/AU.svg": 20247,
	"./country/AW.svg": 28293,
	"./country/AX.svg": 61269,
	"./country/AZ.svg": 68064,
	"./country/BA.svg": 57934,
	"./country/BB.svg": 6285,
	"./country/BD.svg": 41235,
	"./country/BE.svg": 36066,
	"./country/BF.svg": 56433,
	"./country/BG.svg": 20480,
	"./country/BH.svg": 72663,
	"./country/BI.svg": 58278,
	"./country/BJ.svg": 80709,
	"./country/BL.svg": 34219,
	"./country/BM.svg": 19610,
	"./country/BN.svg": 87721,
	"./country/BO.svg": 83480,
	"./country/BQ-BO.svg": 88290,
	"./country/BQ-SA.svg": 9547,
	"./country/BQ-SE.svg": 47991,
	"./country/BR.svg": 55197,
	"./country/BS.svg": 65724,
	"./country/BT.svg": 35907,
	"./country/BV.svg": 14401,
	"./country/BW.svg": 78864,
	"./country/BY.svg": 3510,
	"./country/BZ.svg": 75381,
	"./country/CA.svg": 44989,
	"./country/CC.svg": 95471,
	"./country/CD.svg": 78000,
	"./country/CF.svg": 11058,
	"./country/CG.svg": 60451,
	"./country/CH.svg": 87060,
	"./country/CI.svg": 48341,
	"./country/CK.svg": 74919,
	"./country/CL.svg": 37320,
	"./country/CM.svg": 2713,
	"./country/CN.svg": 76714,
	"./country/CO.svg": 18683,
	"./country/CR.svg": 50126,
	"./country/CU.svg": 15601,
	"./country/CV.svg": 35202,
	"./country/CW.svg": 65779,
	"./country/CX.svg": 75652,
	"./country/CY.svg": 53669,
	"./country/CZ.svg": 17446,
	"./country/DE.svg": 61452,
	"./country/DJ.svg": 76427,
	"./country/DK.svg": 71162,
	"./country/DM.svg": 28068,
	"./country/DO.svg": 69862,
	"./country/DZ.svg": 71099,
	"./country/EC.svg": 68357,
	"./country/EE.svg": 75787,
	"./country/EG.svg": 71817,
	"./country/EH.svg": 35086,
	"./country/ER.svg": 37396,
	"./country/ES.svg": 63029,
	"./country/ET.svg": 52618,
	"./country/FI.svg": 84210,
	"./country/FJ.svg": 72897,
	"./country/FK.svg": 81776,
	"./country/FM.svg": 55518,
	"./country/FO.svg": 89596,
	"./country/FR.svg": 90633,
	"./country/GA.svg": 43049,
	"./country/GB-ENG.svg": 42905,
	"./country/GB-SCT.svg": 46995,
	"./country/GB-UKM.svg": 93120,
	"./country/GB-WLS.svg": 80993,
	"./country/GB.svg": 98234,
	"./country/GD.svg": 8164,
	"./country/GE.svg": 5413,
	"./country/GF.svg": 73638,
	"./country/GG.svg": 62615,
	"./country/GH.svg": 26784,
	"./country/GI.svg": 41169,
	"./country/GL.svg": 65228,
	"./country/GM.svg": 12589,
	"./country/GN.svg": 13262,
	"./country/GP.svg": 12360,
	"./country/GQ.svg": 24729,
	"./country/GR.svg": 75434,
	"./country/GS.svg": 44251,
	"./country/GT.svg": 66548,
	"./country/GU.svg": 4533,
	"./country/GW.svg": 31111,
	"./country/GY.svg": 25313,
	"./country/HK.svg": 60758,
	"./country/HM.svg": 35400,
	"./country/HN.svg": 86139,
	"./country/HR.svg": 43615,
	"./country/HT.svg": 13681,
	"./country/HU.svg": 77728,
	"./country/ID.svg": 67598,
	"./country/IE.svg": 96031,
	"./country/IL.svg": 67942,
	"./country/IM.svg": 82327,
	"./country/IN.svg": 39204,
	"./country/IO.svg": 12754,
	"./country/IQ.svg": 45571,
	"./country/IR.svg": 88528,
	"./country/IS.svg": 24065,
	"./country/IT.svg": 10686,
	"./country/JE.svg": 28410,
	"./country/JM.svg": 44866,
	"./country/JO.svg": 68352,
	"./country/JP.svg": 84583,
	"./country/KE.svg": 54265,
	"./country/KG.svg": 27707,
	"./country/KH.svg": 76444,
	"./country/KI.svg": 30717,
	"./country/KM.svg": 1825,
	"./country/KN.svg": 96786,
	"./country/KP.svg": 70884,
	"./country/KR.svg": 26470,
	"./country/KW.svg": 33035,
	"./country/KY.svg": 5101,
	"./country/KZ.svg": 75982,
	"./country/LA.svg": 46616,
	"./country/LB.svg": 85451,
	"./country/LC.svg": 82746,
	"./country/LI.svg": 7296,
	"./country/LK.svg": 99202,
	"./country/LR.svg": 80123,
	"./country/LS.svg": 62282,
	"./country/LT.svg": 72693,
	"./country/LU.svg": 47060,
	"./country/LV.svg": 18567,
	"./country/LY.svg": 42000,
	"./country/MA.svg": 1583,
	"./country/MC.svg": 27805,
	"./country/MD.svg": 93874,
	"./country/ME.svg": 80835,
	"./country/MF.svg": 91440,
	"./country/MG.svg": 82561,
	"./country/MH.svg": 25142,
	"./country/MK.svg": 61781,
	"./country/ML.svg": 32682,
	"./country/MM.svg": 1499,
	"./country/MN.svg": 69608,
	"./country/MO.svg": 81977,
	"./country/MP.svg": 70510,
	"./country/MQ.svg": 1503,
	"./country/MR.svg": 22476,
	"./country/MS.svg": 69837,
	"./country/MT.svg": 41314,
	"./country/MU.svg": 28691,
	"./country/MV.svg": 84032,
	"./country/MW.svg": 82065,
	"./country/MX.svg": 30886,
	"./country/MY.svg": 19863,
	"./country/MZ.svg": 65412,
	"./country/NA.svg": 93730,
	"./country/NC.svg": 36448,
	"./country/NE.svg": 22926,
	"./country/NF.svg": 22253,
	"./country/NG.svg": 74892,
	"./country/NI.svg": 7898,
	"./country/NL.svg": 72279,
	"./country/NO.svg": 17828,
	"./country/NP.svg": 49603,
	"./country/NR.svg": 34977,
	"./country/NU.svg": 17598,
	"./country/NZ.svg": 34393,
	"./country/OM.svg": 42293,
	"./country/PA.svg": 53972,
	"./country/PE.svg": 4232,
	"./country/PF.svg": 85595,
	"./country/PG.svg": 43626,
	"./country/PH.svg": 11901,
	"./country/PK.svg": 99806,
	"./country/PL.svg": 59713,
	"./country/PM.svg": 44912,
	"./country/PN.svg": 27363,
	"./country/PR.svg": 47159,
	"./country/PS.svg": 84358,
	"./country/PT.svg": 11241,
	"./country/PW.svg": 85658,
	"./country/PY.svg": 75948,
	"./country/QA.svg": 43339,
	"./country/RE.svg": 6450,
	"./country/RO.svg": 56008,
	"./country/RS.svg": 35052,
	"./country/RU.svg": 56450,
	"./country/RW.svg": 64544,
	"./country/SA.svg": 83533,
	"./country/SB.svg": 54414,
	"./country/SC.svg": 59167,
	"./country/SD.svg": 16960,
	"./country/SE.svg": 63409,
	"./country/SG.svg": 71507,
	"./country/SH.svg": 32964,
	"./country/SI.svg": 87685,
	"./country/SJ.svg": 88550,
	"./country/SK.svg": 76087,
	"./country/SL.svg": 56280,
	"./country/SM.svg": 91145,
	"./country/SN.svg": 92410,
	"./country/SO.svg": 95115,
	"./country/SR.svg": 54974,
	"./country/SS.svg": 17551,
	"./country/ST.svg": 51664,
	"./country/SV.svg": 58866,
	"./country/SX.svg": 56724,
	"./country/SY.svg": 82357,
	"./country/SZ.svg": 41110,
	"./country/TC.svg": 3538,
	"./country/TD.svg": 37469,
	"./country/TF.svg": 11247,
	"./country/TG.svg": 74846,
	"./country/TH.svg": 91641,
	"./country/TJ.svg": 11163,
	"./country/TK.svg": 42346,
	"./country/TL.svg": 71445,
	"./country/TM.svg": 33460,
	"./country/TN.svg": 98023,
	"./country/TO.svg": 34806,
	"./country/TR.svg": 38355,
	"./country/TT.svg": 79501,
	"./country/TV.svg": 11167,
	"./country/TW.svg": 80174,
	"./country/TZ.svg": 42667,
	"./country/UA.svg": 91495,
	"./country/UG.svg": 67705,
	"./country/UM.svg": 60067,
	"./country/US.svg": 4869,
	"./country/UY.svg": 10527,
	"./country/UZ.svg": 31500,
	"./country/VA.svg": 96186,
	"./country/VC.svg": 60056,
	"./country/VE.svg": 34854,
	"./country/VG.svg": 6116,
	"./country/VI.svg": 12642,
	"./country/VN.svg": 82861,
	"./country/VU.svg": 80086,
	"./country/WF.svg": 11958,
	"./country/WS.svg": 587,
	"./country/YE.svg": 74799,
	"./country/YT.svg": 95310,
	"./country/ZA.svg": 92054,
	"./country/ZM.svg": 60786,
	"./country/ZW.svg": 41848,
	"./create.svg": 21684,
	"./data-plus.svg": 40241,
	"./delete.svg": 94409,
	"./download-box.svg": 98184,
	"./download-center.svg": 74294,
	"./download.svg": 48800,
	"./draw.svg": 33422,
	"./edit-box.svg": 50892,
	"./file-export.svg": 60501,
	"./file-import.svg": 39208,
	"./file-upload.svg": 97016,
	"./film.svg": 60474,
	"./graphic-delete.svg": 36016,
	"./graphic-style.svg": 57540,
	"./header/header-activeShooting.svg": 77043,
	"./header/header-caseCenter.svg": 79853,
	"./header/header-classify.svg": 54056,
	"./header/header-edit.svg": 3478,
	"./header/header-eventList.svg": 82794,
	"./header/header-globalSearch.svg": 23159,
	"./header/header-globe.svg": 46697,
	"./header/header-play.svg": 58904,
	"./header/header-point-map.svg": 637,
	"./header/header-publicSentiment.svg": 17956,
	"./header/header-publicSentiment1.svg": 70909,
	"./header/header-table.svg": 32214,
	"./header/header-text-search.svg": 19060,
	"./header/header-tradingHall.svg": 74876,
	"./header/header-workbench.svg": 95421,
	"./heat-map.svg": 54531,
	"./hide.svg": 26000,
	"./hotspot-fire.svg": 41154,
	"./image.svg": 28807,
	"./label-change.svg": 4211,
	"./leaflet/district-clear.svg": 91044,
	"./leaflet/district-select.svg": 3833,
	"./leaflet/home-list-point.svg": 61097,
	"./leaflet/map-Layers.svg": 45123,
	"./leaflet/map-LayersCrossed.svg": 8330,
	"./leaflet/map-area.svg": 27262,
	"./leaflet/map-baseSelect.svg": 28294,
	"./leaflet/map-distance.svg": 95272,
	"./leaflet/map-helpDocument.svg": 6055,
	"./leaflet/map-legend.svg": 66666,
	"./leaflet/map-schemaChange.svg": 12456,
	"./leaflet/map-zoom.svg": 30147,
	"./left.svg": 45995,
	"./list-add.svg": 99878,
	"./list-change.svg": 47497,
	"./load-icon.svg": 97070,
	"./loading.svg": 24716,
	"./map-1.svg": 84640,
	"./map-2.svg": 5395,
	"./marker.svg": 62438,
	"./menu-admin-family.svg": 48304,
	"./minus-box.svg": 4880,
	"./osm.svg": 27215,
	"./ph--user-bold.svg": 41109,
	"./plus-border.svg": 72203,
	"./plus-box.svg": 5976,
	"./polygon-icon.svg": 46076,
	"./polygon.svg": 68578,
	"./polyline.svg": 99812,
	"./region-add.svg": 70090,
	"./region-save.svg": 7698,
	"./right.svg": 66478,
	"./save.svg": 64455,
	"./scissor.svg": 25150,
	"./screenshot.svg": 77364,
	"./search.svg": 73548,
	"./service-upload.svg": 29325,
	"./show.svg": 24579,
	"./side.svg": 35833,
	"./square.svg": 51933,
	"./switch.svg": 77980,
	"./system-admin.svg": 66089,
	"./task-icon.svg": 89379,
	"./text-border.svg": 97932,
	"./thumbtack.svg": 56031,
	"./user-info-password.svg": 83264,
	"./user-info-user.svg": 8582,
	"./word.svg": 16320,
	"./work-bench.svg": 17098,
	"./work-space.svg": 81122,
	"./world-icon.svg": 4710,
	"./world-image.svg": 65504,
	"./world.svg": 73908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71525;